__turbopack_context__.v({
  "card": "DelegationSection-module-scss-module__FXUF3W__card",
  "cardAccent": "DelegationSection-module-scss-module__FXUF3W__cardAccent",
  "cardImage": "DelegationSection-module-scss-module__FXUF3W__cardImage",
  "cardLabel": "DelegationSection-module-scss-module__FXUF3W__cardLabel",
  "cards": "DelegationSection-module-scss-module__FXUF3W__cards",
  "check": "DelegationSection-module-scss-module__FXUF3W__check",
  "container": "DelegationSection-module-scss-module__FXUF3W__container",
  "containerWarehouse": "DelegationSection-module-scss-module__FXUF3W__containerWarehouse",
  "content": "DelegationSection-module-scss-module__FXUF3W__content",
  "description": "DelegationSection-module-scss-module__FXUF3W__description",
  "eyebrow": "DelegationSection-module-scss-module__FXUF3W__eyebrow",
  "lead": "DelegationSection-module-scss-module__FXUF3W__lead",
  "link": "DelegationSection-module-scss-module__FXUF3W__link",
  "note": "DelegationSection-module-scss-module__FXUF3W__note",
  "section": "DelegationSection-module-scss-module__FXUF3W__section",
  "task": "DelegationSection-module-scss-module__FXUF3W__task",
  "taskList": "DelegationSection-module-scss-module__FXUF3W__taskList",
  "title": "DelegationSection-module-scss-module__FXUF3W__title",
});
